export default __webpack_public_path__ + "static/media/ca-5-rMAX.6e4b297f.avif";